<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile">
  <div class="d-flex justify-content-between">
    <div class="zero-text p-bigger-med mb-2">{{ 'asset-class-overview.etf-overview.etfs-by-indices.headline' | transloco }}</div>
    <web-design-system-icon-button (click)="collapse()" type="grey-light" size="small" [icon]="collapsed() ? 'chevron' : 'chevron-2'" />
  </div>
  @if (!collapsed()) {
    <div class="zero-text p-small-reg label mb-3">{{ 'asset-class-overview.etf-overview.etfs-by-indices.text' | transloco }}</div>
    <web-design-system-tab-navigation [model]="tabModel()" (tabChange)="onTabChange($event)" />
    <table class="table-simple mt-3">
      <thead class="hidden-xs">
        <tr>
          <th>{{ 'asset-class-overview.etf-overview.etfs-by-indices.name' | transloco }}</th>
          <th class="text-right">{{ 'asset-class-overview.etf-overview.etfs-by-indices.costs' | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @if (!etfs()?.length) {
          <tr>
            <td colspan="2">{{ 'asset-class-overview.etf-overview.etfs-by-indices.no-data' | transloco }}</td>
          </tr>
        }
        @for (etf of etfs(); track $index) {
          <tr>
            <td class="d-block d-sm-table-cell">
              <div class="d-flex align-items-center gap-small justify-content-between">
                <div class="hidden-lg hidden-xl hidden-md hidden-sm">
                  {{ 'asset-class-overview.etf-overview.etfs-by-indices.name' | transloco }}
                </div>
                <div class="text-md-left text-right zero-text p-base-med">
                  <web-components-instrument-details-link linkCssClass="zero-text p-base-med default" [isin]="etf.isin">{{
                    etf.name
                  }}</web-components-instrument-details-link>
                </div>
              </div>
            </td>
            <td class="d-block d-sm-table-cell text-right text-nowrap">
              <div class="d-flex align-items-center gap-small justify-content-between justify-content-md-end">
                <div class="hidden-lg hidden-xl hidden-md hidden-sm">
                  {{ 'asset-class-overview.etf-overview.etfs-by-indices.costs' | transloco }}
                </div>
                <div>{{ etf.cost | number: '1.2-2' }} %</div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
